import { TextTransformType } from "../../actions/text-transform/createTextTransform";

export enum TransformPanelUiAction {
  CUSTOM_TOGGLE = "custom_toggle",
  RESET = "reset",
}

export enum TransformStorageKey {
  CUSTOM_PROMPTS = "ai-scribe-custom-prompts",
}

export interface CustomPromptButtonConfig {
  title: string;
  prompt: string;
}

export interface TransformAction {
  label: string;
  icon: string;
  type: TextTransformType | TransformPanelUiAction;
}

export const CUSTOM_PROMPT_SLOTS = 6;

export const DEFAULT_FEE_NOTE_PROMPT = [
  "You are a South African legal fee note formatter. Process dictated fee note text into a clean, structured fee note using the rules below.",
  "",
  "HEADER:",
  "First line: MATTER: [W-number] [Party1] v [Party2]",
  "No 'PARTIES:' label. Matter number and party names on one line only.",
  "The matter number is ALWAYS the letter W followed by exactly 5 digits.",
  "Strip ALL spaces, slashes, hyphens or any other characters between the digits.",
  "The speaker says names then spells them. Use the spelled-out version as authoritative.",
  "Use 'v' not 'vs'. Ignore introductory phrases.",
  "",
  "FEE ENTRY FORMAT:",
  "Each entry on its own line: '[date]: [description], [X] units.'",
  "Use natural prose with proper articles. Capitalise only the first word.",
  "End each entry with a full stop. Leave a blank line between each entry.",
  "",
  "DATES - CRITICAL:",
  "Format: '[day] [month]' e.g. '6 March'.",
  "NEVER omit the day number. 'Same date' repeats previous date including day number.",
  "",
  "NUMBERS - CRITICAL:",
  "Every number as a numeral, never a word.",
  "'half unit' -> '0.5 units'. No exceptions.",
  "",
  "NO CHARGE:",
  "If 'no charge' or 'NC', end entry with '(no charge)' instead of units.",
  "",
  "CLOSING:",
  "After last entry: That is all.",
  "",
  "NO totals, NO subtotals, NO markdown, plain text only.",
].join("\n");

export const TRANSFORM_ACTIONS: TransformAction[] = [
  { label: "Summary", icon: "📋", type: "summary" },
  { label: "Letter", icon: "✉️", type: "letter" },
  { label: "Email", icon: "📧", type: "email" },
  { label: "Update", icon: "📨", type: "update" },
  { label: "Improve", icon: "✨", type: "improve" },
  { label: "Other", icon: "✏️", type: TransformPanelUiAction.CUSTOM_TOGGLE },
  { label: "Reset", icon: "↩", type: TransformPanelUiAction.RESET },
];

export const DEFAULT_CUSTOM_PROMPTS: Record<number, CustomPromptButtonConfig> = {
  0: {
    title: "Fees",
    prompt: DEFAULT_FEE_NOTE_PROMPT,
  },
};
